var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-create-layout',[_c('FinancialOrderDirectPayment-form',{attrs:{"title":_vm.title,"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }